import { useEffect, useState, ChangeEvent } from 'react';
import {
  DevHubBox,
  DevHubFormControl,
  DevHubFormControlLabel,
  DevHubRadio,
  DevHubRadioGroup,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';

export interface AuthenticationData {
  requiresLogin?: boolean;
}

interface AuthenticationDetailsProps {
  authData: AuthenticationData;
  setAuthData: (data: AuthenticationData) => void;
  setValidationHasError: (hasError: boolean) => void;
}

/**
 * Authentication Details component for application onboarding
 * @param props - AuthenticationDetailsProps
 */
const AuthenticationDetails = ({
  authData,
  setAuthData,
  setValidationHasError,
}: AuthenticationDetailsProps) => {
  const getInitialValue = () => {
    if (authData.requiresLogin === undefined) return '';
    return authData.requiresLogin ? 'yes' : 'no';
  };

  const [requiresLogin, setRequiresLogin] = useState<string>(getInitialValue());

  const handleRequiresLoginChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setRequiresLogin(value);

    const updatedData = {
      ...authData,
      requiresLogin: value === 'yes',
    };

    setAuthData(updatedData);
  };

  useEffect(() => {
    const isValid = requiresLogin !== '';
    setValidationHasError(!isValid);
  }, [requiresLogin, setValidationHasError]);

  return (
    <DevHubBox>
      <DevHubBox mt={3}>
        <DevHubFormControl component="fieldset" required>
          <DevHubTypography variant="subtitle1" gutterBottom>
            Does the application include a user interface which requires a
            login? *
          </DevHubTypography>
          <DevHubRadioGroup
            value={requiresLogin}
            onChange={handleRequiresLoginChange}
          >
            <DevHubFormControlLabel
              value="yes"
              control={<DevHubRadio />}
              label="Yes"
            />
            <DevHubFormControlLabel
              value="no"
              control={<DevHubRadio />}
              label="No"
            />
          </DevHubRadioGroup>
        </DevHubFormControl>
      </DevHubBox>
    </DevHubBox>
  );
};

export default AuthenticationDetails;
